import { RouteComponentProps } from "@reach/router"
import React from "react"
import { useGetByPk } from "../../apollo/networking/use-get-by-pk"
import { FeatureFlag } from "../../auth/feature-flags"
import { useOrg } from "../../auth/use-org"
import { AppLayout } from "../../layout/app-layout"
import { EventFragment, EventModel } from "../../models/event.model"
import { ErrorPage } from "../../ui/errors"
import { LoadingDots } from "../../ui/loading-dots"
import { PageHeader } from "../../ui/page-header"
import { ResourcesList } from "./resources-list"

type Props = {
    event_id: number;
}

export const EventResourcesPage = ({
    event_id,
}: RouteComponentProps<Props>) => {
    const { entity, loading } = useGetByPk<EventModel>({
        entity_name: 'event',
        fragment: EventFragment,
        pk_columns: [{
            name: 'id',
            type: 'bigint',
            value: event_id,
        }]
    })
    const is_feature_active = useOrg()
        .getFeatureFlag(FeatureFlag.resources);

    if (!is_feature_active) {
        return <ErrorPage
            title='Feature is not active!'
            message='Event resources/notes feature is not active on your account. Please contact us at help@certifysimple.com to activate this feature.'
        />
    }

    return <AppLayout>
        <PageHeader title='Resources' />
        {loading ? <LoadingDots /> : null}
        {entity ? <ResourcesList event={entity} /> : null}
    </AppLayout>
}
